module.exports = __webpack_public_path__ + "static/media/td-1.16eb6aa0.png";